import styled from 'styled-components'

export const Container = styled.li``

interface MainProps {
  isOpen: boolean
}

export const Main = styled.label<MainProps>`
  position: relative;
  width: 100%;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 1rem;

  border-radius: 5px;
  background: ${({ isOpen, theme }) => (isOpen ? theme.colors.colorf7f9fc : theme.zds.colors.neutral1000)};
  cursor: pointer;
  color: ${props => props.theme.colors.color6b7786};
  &:hover {
    background: ${props => props.theme.colors.colorf7f9fc};
  }
  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.color378ff7};
  }

  svg {
    fill: ${props => props.theme.colors.color545e6c};
    width: 8px;
  }
`

export const Title = styled.span`
  position: relative;
  width: 100%;
  text-align: left;
  font: normal normal bold 14px/22px Inter;
  line-height: 18px;
  color: ${props => props.theme.colors.color6b7786};

  span {
    font: normal normal normal 12px/22px Inter;
  }
`
export const ExpandableContentItem = styled.div`
  position: relative;
  width: 100%;
  padding-left: 6px;
  margin-top: 8px;
  max-width: fit-content;
  min-height: 140px;
  text-align: justify;
`

export const ExpandableItem = styled.span`
  font: normal normal normal 12px/22px Inter;
  text-align: justify;
  word-break: break-all;
`
